var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-wrapper"},[_c('div',{ref:"trigger",staticClass:"trigger",on:{"click":_vm.toggle}},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}})]),(_vm.visible)?_c('div',{ref:"menu",staticClass:"dropdown",style:(_vm.style)},[_c('div',{staticClass:"arrow"}),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }